<template lang="pug">
Button(
  type="primary"
  label="New Creative"
  :disabled="disbale_new_creative"
  data-intercom-target="new-creative-button"
  v-google-analytics="{ key: 'click', element_name: 'create creative start' }"
  v-user-guiding="'new-creative-button'"
  style="overflow:visible;"
  @click="createPlacement('infeed')"
)
  Dropdown.dropdown-create-placement(
    v-if="placement_dropdown_options"
    :disabled="disbale_new_creative"
    position="right"
    :ga="true"
    :options="placement_dropdown_options"
    :stop="true"
  )
    template(v-slot:button="scope")
      div.dropdown-arrow
        i.nexd-icon-16-arrow-down(aria-hidden="true" :class="{'active': scope.opened}")
</template>

<script>
import CreativesMixins from '@cm/Views/Creatives/Components/CreativesMixins';

import Button from '@master/UI/Buttons/Button';
import IconDropdown from '@master/UI/Buttons/Icons/IconDropdown';
import Dropdown from '@master/UI/Dropdown';

export default {
  name: 'CreativesCreatePlacement',
  mixins: [CreativesMixins],
  components: {
    Button,
    Dropdown,
    IconDropdown,
  },

  props: {
    disbale_new_creative: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    placement_dropdown_options() {
      const desktop_icon = {
        icon: 'nexd-icon-16-desktop',
        tooltip: { value: 'This creative type works well on desktop devices' },
      };
      const mobile_icon = {
        icon: 'nexd-icon-16-mobile',
        tooltip: { value: 'This creative type works well on mobile devices' },
      };
      const video_icon = {
        icon: 'nexd-icon-16-video',
        value: 'This creative type is meant for in-stream platforms on all devices',
      };

      let options = [];

      if (!this.instream_expert) {
        options.push({
          label: 'Standard infeed',
          tooltip: { template: 'cm.standard_infeed', position: 'left' },
          onclick: () => {
            this.createPlacement('infeed');
          },
          suffix: [desktop_icon, mobile_icon],
        });
        options.push({
          label: 'Interstitial',
          tooltip: { template: 'cm.interstitial', position: 'left' },
          onclick: () => {
            this.createPlacement('interstitial');
          },
          suffix: [mobile_icon],
        });
        options.push({
          label: 'Interscroller',
          tooltip: { template: 'cm.interscroller', position: 'left' },
          onclick: () => {
            this.createPlacement('interscroller');
          },
          suffix: [mobile_icon],
        });
        options.push({
          label: 'Expandable',
          tooltip: { template: 'cm.expandable', position: 'left' },
          onclick: () => {
            this.createPlacement('expandable');
          },
          suffix: [mobile_icon],
        });
        options.push({
          label: 'Dynamic endcard',
          tooltip: { template: 'cm.endcard', position: 'left' },
          onclick: () => {
            this.createPlacement('endcard');
          },
          suffix: [mobile_icon],
        });
        options.push({
          label: 'Lightbox',
          tooltip: { template: 'cm.lightbox', position: 'left' },
          onclick: () => {
            this.createPlacement('lightbox');
          },
          suffix: [desktop_icon, mobile_icon],
        });
      }

      // only show rsponsive option to valid users
      if (this.show_responsive_type_option) {
        options.push({
          label: 'Responsive',
          tooltip: { template: 'cm.responsive', position: 'left' },
          onclick: () => {
            this.createPlacement('responsive');
          },
          suffix: [desktop_icon, mobile_icon],
        });
      }

      options.push(
        {
          label: 'VAST Video',
          tooltip: { template: 'cm.vast', position: 'left' },
          onclick: () => {
            this.createPlacement('vast');
          },
          suffix: [video_icon],
        },
        {
          label: 'CTV VAST Video',
          tooltip: { template: 'cm.ctv_vast', position: 'left' },
          onclick: () => {
            this.createPlacement('ctv_vast');
          },
          suffix: [video_icon],
        },
        {
          label: 'VPAID Video',
          tooltip: { template: 'cm.vpaid', position: 'left' },
          onclick: () => {
            this.createPlacement('vpaid');
          },
          suffix: [video_icon],
        },
      );

      return options;
    },
  },

  methods: {
    createPlacement(type) {
      if (this.disbale_new_creative) return;
      this.$emit('createPlacement', type);
    },
  },
};
</script>
